import React, { useEffect, useRef, useState } from 'react';
import styles from './Me.module.css';
import orlyImage from "../../images/קרן אקסלרוד תמונת תדמית לבן.png";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Popped from '../poppedUpWindow/Popped';

gsap.registerPlugin(ScrollTrigger);

const AboutMe = () => {
  const containerRef = useRef(null);
  const quoteRef = useRef(null);
  const strongTextRefs = useRef([]);
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);

  useEffect(() => {
    if (quoteRef.current) {
      gsap.fromTo(
        quoteRef.current,
        { opacity: 0, scale: 0.8, rotationY: 15 },
        {
          opacity: 1,
          scale: 1,
          rotationY: 0,
          duration: 1.5,
          ease: "power3.out",
          scrollTrigger: {
            trigger: quoteRef.current,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    strongTextRefs.current.forEach((ref, index) => {
      if (ref) {
        gsap.fromTo(
          ref,
          { opacity: 0, x: -50, scale: 0.9 },
          {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 1.2,
            ease: "power2.out",
            delay: index * 0.2,
            scrollTrigger: {
              trigger: ref,
              start: "top 85%",
              end: "bottom 15%",
              toggleActions: "play none none reverse"
            }
          }
        );
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  return (
    <>
      <section ref={containerRef} className={styles.section} id="מי אנחנו">
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            <img src={orlyImage} alt="קרן אקסלרוד" className={styles.image} />
          </div>

          <div className={styles.content}>
            <h2 className={styles.mainTitle}>נעים מאוד, קרן אקסלרוד</h2>

            <div className={styles.quoteContainer} ref={quoteRef}>
              <p className={styles.quote}>"אני כאן כדי להפוך את מה שכולם אומרים לך 'את כל כך טובה בזה' – למקצוע שמכניס לך 5 ספרות בחודש"</p>
            </div>

            <div className={styles.textBlock}>
              <p className={styles.paragraph}>
                אני זוכרת את עצמי כבר בגיל צעיר מחפשת פתרונות. מישהו היה מספר על בעיה והראש שלי כבר היה שם – מסדר, מארגן, מוצא את הדרך. לא חיכיתי שיבקשו ממני עזרה. פשוט ראיתי את הפתרון לפני כולם.
              </p>

              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                כשנכנסתי לעבוד בחברת תקשורת גדולה, הכישרון הזה קיבל במה אמיתית. התחלתי כנציגת שירות, אבל תוך זמן קצר כבר ניהלתי מוקדי שימור ומרכזי שירות. צוותים של עשרות אנשים, לחצים מכל כיוון, תהליכים מורכבים – ואני שולטת בהכל במקביל והופכת כאוס למערכת שמתפקדת כמו שעון שוויצרי.
              </p>

              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                הקמתי משרד, ובמשך עשור שלם ליוויתי מאות לקוחות מרוצים. בניתי מערכות, סידרתי תהליכים, והפכתי כאוס לסדר. כל לקוח היה עולם ומלואו, וכל פתרון היה מותאם אישית. <br/><strong>ועכשיו? אני לוקחת את כל הניסיון הזה – ומלמדת נשים כמוך לעשות בדיוק את אותו הדבר.</strong>
              </p>

              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                הבנתי שיש אלפי נשים בדיוק כמוני – נשים שכולם פונים אליהן כש"יש בעיה", שיודעות לתקתק עניינים, שרואות פתרון איפה שאחרים רואים בלאגן. אבל הן תקועות כרגע בעבודה שהן לא אוהבות, עושות טובות בחינם, ולא מבינות שהכישרון הזה שווה הרבה מאוד כסף.
              </p>

              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                המטרה שלי היא להפוך אותך לבעלת עסק עצמאי שעובדת מכל מקום בעולם, וסוף סוף מקבלת את ההכרה (והתגמול) על הערך העצום שאת מביאה.
              </p>

              <button className={styles.ctaButton} onClick={handleButtonClick} style={{ marginTop: '2rem' }}>
                <span className={styles.buttonIcon}>💬</span>
                בואי נדבר, אני כאן בשבילך
              </button>
            </div>
          </div>     
        </div>
      </section>
      
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}
    </>
  );
};

export default AboutMe;